"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var refund_request_1 = require("./refund_request");
var refund_explanation_line_items_1 = require("./refund_explanation_line_items");
var checkMark = '<span class="fa fa-check fa-li color-green"></span>';
var LineItem = function (props) {
    return React.createElement(sanitized_render_1.default, { htmlTag: "li", html: "" + checkMark + props.text });
};
var RefundExplanation = function (props) {
    if (props.refundState === refund_request_1.IRefundState.DENIED) {
        return null;
    }
    var items = refund_explanation_line_items_1.getRefundExplanationLineItems(props.userType, props.refundType, props.order, props.refundState, props.refundRequest, props.refundAmount, props.refundReason);
    return (React.createElement("div", { className: "form-group" },
        React.createElement("div", { className: "form-group__header" },
            React.createElement("label", null, I18n.t('discovery.dashboard.refundRequests.explanation.heading'))),
        React.createElement("div", { className: "form-group__fields" },
            React.createElement("ul", { className: "fa-ul size-90" }, items.map(function (text, i) { return React.createElement(LineItem, { text: text, key: "refund-item-" + i }); })))));
};
exports.default = RefundExplanation;
//# sourceMappingURL=refund_explanation.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_explanation.js
// module id = 6Pf0
// module chunks = 20 21